import { create } from "zustand";

interface KakaoAccount {
  age_range: string; // 나이대 (예: "20~29")
  age_range_needs_agreement: boolean; // 나이대 동의 필요 여부
  birthday: string; // 생일 (MMDD 형식)
  birthday_needs_agreement: boolean; // 생일 동의 필요 여부
  birthday_type: "SOLAR" | "LUNAR"; // 생일 유형 (양력/음력)
  birthyear: string; // 출생 연도
  birthyear_needs_agreement: boolean; // 출생 연도 동의 필요 여부
  email: string; // 이메일
  email_needs_agreement: boolean; // 이메일 동의 필요 여부
  gender: "male" | "female"; // 성별
  gender_needs_agreement: boolean; // 성별 동의 필요 여부
  has_age_range: boolean; // 나이대 정보 포함 여부
  has_birthday: boolean; // 생일 정보 포함 여부
  has_birthyear: boolean; // 출생 연도 포함 여부
  has_email: boolean; // 이메일 정보 포함 여부
  has_gender: boolean; // 성별 정보 포함 여부
  has_phone_number: boolean; // 전화번호 정보 포함 여부
  is_email_valid: boolean; // 이메일 유효 여부
  is_email_verified: boolean; // 이메일 인증 여부
  is_leap_month: boolean; // 윤달 여부
  name: string; // 이름
  name_needs_agreement: boolean; // 이름 동의 필요 여부
  phone_number: string; // 전화번호 (국가 코드 포함)
  phone_number_needs_agreement: boolean; // 전화번호 동의 필요 여부
}

interface KakaoUser {
  connected_at: string;
  id: number;
  synched_at: string;
  kakao_account: KakaoAccount;
  trkId?: string;
}

interface User {
  isLoggedIn: boolean;
  kakaoUser: KakaoUser | null;
}

interface PostUserResponse {
  is: "Available" | "Unavailable";
  contents: "Login Success" | "Login Fail";
}

interface PostData {
  postData: PostUserResponse | null;
}

interface KakaoAction {
  // 카카오 유저 정보 Zustand에 세팅
  setKakaoUser: (kakaoUser: KakaoUser) => void;

  // 유저 등록
  postUser: (kakaoUser: KakaoUser) => void;
}

const initialState: User & PostData = {
  isLoggedIn: false,
  kakaoUser: null,
  postData: null,
};

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const useKakaoStore = create<User & PostData & KakaoAction>(
  (set, get) => ({
    ...initialState,
    setKakaoUser: (kakaoUser: KakaoUser) => {
      set({ kakaoUser, isLoggedIn: true });
      get().postUser(kakaoUser);
    },

    postUser: async (kakaoUser: KakaoUser) => {
      const response = await fetch(`${BASE_URL}/user/post`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(kakaoUser),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const postData = await response.json();

      set({ postData });
    },
  })
);
